
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.334 8a2.667 2.667 0 115.333 0 2.667 2.667 0 01-5.333 0zM3.892 8a4.108 4.108 0 108.216 0 4.108 4.108 0 00-8.216 0zm7.419-4.27a.96.96 0 10.96-.96.96.96 0 00-.96.96zM4.768 14.511c-.78-.036-1.204-.166-1.485-.275a2.486 2.486 0 01-.92-.599 2.468 2.468 0 01-.6-.92c-.109-.28-.239-.705-.274-1.485-.04-.843-.047-1.097-.047-3.233s.008-2.389.047-3.233c.035-.78.166-1.203.275-1.486.145-.373.318-.64.598-.92.28-.28.546-.453.92-.598.282-.11.706-.24 1.486-.275.843-.04 1.097-.047 3.232-.047 2.136 0 2.39.009 3.233.047.78.035 1.204.166 1.486.275.374.145.64.318.92.598.28.28.453.547.599.92.11.282.24.706.275 1.486.039.844.046 1.097.046 3.233s-.007 2.39-.046 3.233c-.036.78-.166 1.204-.275 1.486-.146.373-.319.64-.599.92-.28.279-.546.452-.92.598-.281.11-.706.24-1.486.275-.843.039-1.096.046-3.233.046-2.136 0-2.389-.007-3.232-.046zM4.702.048C3.85.088 3.268.222 2.76.42a3.924 3.924 0 00-1.417.923c-.445.444-.719.89-.923 1.417-.198.508-.333 1.09-.372 1.942C.01 5.555 0 5.827 0 8c0 2.172.009 2.445.048 3.298.04.852.174 1.434.372 1.942.204.526.478.973.923 1.417.445.445.89.718 1.417.923.51.198 1.09.333 1.942.372C5.555 15.99 5.828 16 8 16c2.173 0 2.446-.009 3.299-.048.851-.04 1.433-.174 1.942-.372a3.934 3.934 0 001.417-.923c.445-.444.718-.89.923-1.417.197-.508.333-1.09.371-1.942.039-.853.048-1.126.048-3.298 0-2.173-.009-2.445-.048-3.298-.039-.852-.174-1.434-.371-1.942a3.934 3.934 0 00-.923-1.417A3.915 3.915 0 0013.24.42C12.732.222 12.151.087 11.3.048 10.446.01 10.174 0 8.001 0S5.555.009 4.702.048z","fill":"#fff"}})])
          )
        }
      }
    